module.exports = __webpack_public_path__ + "static/media/banner_alibaba.161d5f54.jpg";